import { queryOptions, useQuery } from "@tanstack/react-query";
import {
  fetchMarketplace,
  fetchMarketplaceCustomers,
} from "../clients/marketplaceClient";

export const marketplaceCustomersQueryOptions = () =>
  queryOptions({
    queryKey: ["marketplace-customers"],
    queryFn: fetchMarketplaceCustomers,
    staleTime: 5 * 60_000,
  });

export const marketplaceQueryOptions = (
  externalCustomerId?: string,
  enabled = true,
) =>
  queryOptions({
    queryKey: ["marketplace", externalCustomerId ?? "current"],
    queryFn: () => fetchMarketplace(externalCustomerId),
    enabled,
    staleTime: 5 * 60_000,
    meta: { errorMessage: "Marketplace could not be loaded." },
  });

export function useMarketplaceCustomers() {
  return useQuery(marketplaceCustomersQueryOptions());
}

export function useMarketplace(externalCustomerId?: string, enabled = true) {
  return useQuery(marketplaceQueryOptions(externalCustomerId, enabled));
}
